import Logger from '../logger';
import event from '../mixins/event';

class StatsShapesSection {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'StatsShapesSection';

		this.dom = dom;

		this.numberDoms = this.dom.querySelectorAll(`[data-stats-shapes-section-number]`);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initNumbers();
	}

	/**
	 * initNumbers - Initialize the numbers
	 * https://jshakespeare.com/simple-count-up-number-animation-javascript-react/
	 */
	initNumbers() {
		Logger.info(`${this.NAME} > initNumbers`);

		if (!this.numberDoms) return;

		// How long you want the animation to take, in ms
		const animationDuration = 750;

		// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
		const frameDuration = 1000 / 60;

		// Use that to calculate how many frames we need to complete the animation
		const totalFrames = Math.round(animationDuration / frameDuration);

		// An ease-out function that slows the count as it progresses
		const easeOutQuad = t => t * (2 - t);

		// The animation function, which takes an Element
		const animateCountUp = el => {
			let frame = 0;
			const countTo = parseInt(el.getAttribute(`data-stats-shapes-section-number`), 10);

			// Start the animation running 60 times per second
			const counter = setInterval(() => {
				frame++;
				// Calculate our progress as a value between 0 and 1
				// Pass that value to our easing function to get our
				// progress on a curve
				const progress = easeOutQuad(frame / totalFrames);
				// Use the progress value to calculate the current count
				const currentCount = Math.round(countTo * progress);

				// If the current count has changed, update the element
				if (parseInt(el.innerHTML, 10) !== currentCount) {
					el.innerHTML = currentCount;
				}

				// If we’ve reached our last frame, stop the animation
				if (frame === totalFrames) {
					clearInterval(counter);
				}
			}, frameDuration);
		};


		const observer = new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					const intersecting = entry.isIntersecting;
					if (intersecting && entry.target.innerHTML === '0') {
						animateCountUp(entry.target);
					}
				}
			},
			// 👇 Threshold is 100%
			{ threshold: 1 }
		);

		this.numberDoms.forEach((dom) => {
			observer.observe(dom);
		});

	}

}

Object.assign(StatsShapesSection.prototype, event);

export default StatsShapesSection;
